import { define } from '../../define.js';
import { Alert } from './alert.js';
export * from './alert.js';
define('alert', Alert);
